module.exports = __webpack_public_path__ + "assets/angularjs.2848acb8.svg";